module.exports = __webpack_public_path__ + "static/media/av.941b5217.png";